import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  deleteAlbumImages,
  removeAlbumImagesFromState,
} from "../../../../../store/slices/Album/AlbumDetails";
import { getAlbums } from "../../../../../store/slices/albumSlice";
import {
  getAllImagesTotalCount,
  removeImageFromState,
} from "../../../../../store/slices/GalleryImagesSlice";
import { clearImageAlbumState } from "../../../../../store/slices/GalleryTabSlice";
import { getGalleryitems, getProfileDetails, updatePlanPercentage } from "../../../../../store/slices/userprofileSlice";
import { getAllImages } from "../../../../../store/slices/Gallery/fileUploadSlce";
import { getTrashList } from "../../../../../store/slices/Trash/trashSlice";

export const useDeleteAlbumImageModal = ({ setDeleteModal, albumId }) => {
  const dispatch = useDispatch();
  // const { albumId } = useParams();

  const selectedAlbumImage = useSelector(
    (state) => state.galleryTab.ImageAlbumDetailsTab
  );
  const { galleryAllTab, favorite, album, archive, slideshow, trash } =
    useSelector((state) => state);
    const { userdata } = useSelector((store) => store.userprofile);
  const albumList = useSelector((state) => state?.album?.resultData?.data);
  const { isDeletingAlbum, isDeletingAll } = useSelector(
    (state) => state?.albumDetails
  );
  const selections = useSelector((state) => state.galleryTab);
  let albumDetailsIndex = albumList?.findIndex((obj) => obj.id == albumId);

  let albumDetails = albumDetailsIndex !== undefined && albumDetailsIndex !== null ? albumList[albumDetailsIndex] : [];
  const fileUploadState = useSelector((state) => state.fileUpload);
  const fileAlbumState = useSelector((state) => state.albumDetails);

  const handleDelete = async (type) => {
    let image_id = selectedAlbumImage?.selectedImage;
    let album_id = albumId;

    const resultAction = await dispatch(
      deleteAlbumImages({ image_id, album_id, type })
    );
    if (deleteAlbumImages.fulfilled.match(resultAction)) {
      dispatch(removeAlbumImagesFromState(image_id));
      await dispatch(getProfileDetails());


      if (type == "permanent") {
        dispatch(removeImageFromState({ image_id }));
        dispatch(getAllImages());
      }
      let obj = {
        page: "1",
        slug: "",
      };
      dispatch(getAlbums(obj));

      toast.success("Images deleted !", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setDeleteModal({ popup: false });
    }
  };

  const handleClose = () => {
    setDeleteModal({ popup: false });
    dispatch(clearImageAlbumState());
  };

  return {
    selectedAlbumImage,
    handleDelete,
    albumDetails,
    handleClose,
    isDeletingAlbum,
    isDeletingAll,
  };
};
